import { render, staticRenderFns } from "./AudioQualityIndicator.vue?vue&type=template&id=634bbc16&scoped=true"
import script from "./AudioQualityIndicator.vue?vue&type=script&lang=js"
export * from "./AudioQualityIndicator.vue?vue&type=script&lang=js"
import style0 from "./AudioQualityIndicator.vue?vue&type=style&index=0&id=634bbc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634bbc16",
  null
  
)

export default component.exports